import { OwnerStatementSummariesMonthsFilter } from '../detail/OwnerStatementSummariesDetailFilter';
import { useOwnerStatementSummariesDetailContext } from '../detail/_context';
import { useNavigate } from 'react-router';

export const STORYBOOK_OWNER_STATEMENT_SUMMARIES_RANGE_MIN_MAX_QUERY_KEY =
  'owner-statement-summaries-range-min-max';

export const OwnerStatementSummariesTableFilter = () => {
  const { monthRange } = useOwnerStatementSummariesDetailContext();

  const goto = useNavigate();

  return (
    <OwnerStatementSummariesMonthsFilter
      monthRange={monthRange}
      setMonthRange={(v) => goto(`/reports/statement-summaries/list/${v}`)}
    />
  );
};
